export const GetImageByConfig = (productImagesArray, model, modelType, year) => {
  const productImageObj = Array.isArray(productImagesArray)
    ? productImagesArray.find(img => img.modelType === modelType && img.year === year && img.model === model)
    : null
  return productImageObj?.image
}
